import React from 'react';
import {observer} from 'mobx-react';
import FilterComponent from './FilterComponent';

const ReviewQuestion = observer(({models, filter, filterKey, filterUpdated, filterDeleted, Wrapper}) => {
  const options = models.map(question => {
    return { label:  question.name, value:  question.id};
  });

  return <FilterComponent
    filter={filter}
    filterKey={filterKey}
    options={options}
    filterUpdated={filterUpdated}
    filterDeleted={filterDeleted}
    Wrapper={Wrapper}
    searchable
  />;
});

export default ReviewQuestion;
